import { render } from "./MagnificientGlassIcon.vue?vue&type=template&id=71debb78"
const script = {}

import "./MagnificientGlassIcon.vue?vue&type=style&index=0&id=71debb78&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__